import React from "react";
import { Table, ConfigProvider } from "antd";
import PropTypes from "prop-types";

const ModalTable = ({ data, loading }) => {
  ModalTable.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
  };

  const columns = [
    {
      title: "Emp#",
      dataIndex: "employeeNumber",
      key: "employeeNumber",
      align: "center",
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      key: "employeeName",
      align: "center",
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      align: "center",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "employeeStatus",
      key: "employeeStatus",
      align: "center",
    },
  ];

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: "white",
          margin: 16,
          boxShadowSecondary:
            "0 4px 8px 0 rgba(0, 0, 0.5, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: 8,
          padding: 25,
        },
        components: {
          Table: {
            headerBg: "#FF7201",
            headerColor: "white",
            headerSplitColor: "#2C2C2C",
          },
        },
      }}
    >
      <Table
        rowKey={(record) => record.employeeNumber + record.employeeName}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: true }}
      />
    </ConfigProvider>
  );
};

export default ModalTable;
